import { Column } from "../CustomDataTable/CustomDataTable";
import { Link } from "react-router-dom";
import { TfiMoreAlt } from "react-icons/tfi";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import ActionMenuItems from "../Menu/ActionMenu";
import OptionMenu from "../Menu/OptionMenu";

interface CommonColumnsProps {
    handleEditCustomer: (customer: any) => void;
    handleRowMenuOpen: (event: any, contactId: number) => void;
    handleDeleteCustomer: (contactId: number) => void;
    handleActiveDeactiveCustomer: (row: any) => void;
    handleOpenEditPointDialog: (mobNo?: string, points?: number | null) => void;
    handleResetPoint: (mobNo?: string, points?: number | null) => void;
    openRowMenuId: number | null;
    menuRef: React.RefObject<DropdownMenu>;
    dynamicMenuAction: any;
    tabView: string;
    contactType: string;
    sessionBranchId: number;
    pagination: {
        page: number,
        pages: number,
        perpage: number,
        total: number,
    }
    sessionList:any
}

export const commonFieldColumns = ({
  pagination,
  contactType,
  sessionList,
}: CommonColumnsProps): Column[] => [
  {
    field: "srNo",
    headerName: "Sr. No",
    width: 70,
    defaultChecked: true,
    renderCell: (params: any) => {
      return (
        pagination.page * pagination.perpage + params.row.index
      ) 
    }
  },
  {
    field: "name",
    headerName: "Name",
    filtering: true,
    exportPdfName: (params: any) => {
      const { firstName = "", lastName = "", companyName = "" } = params.row;
      const nameParts = [firstName, lastName, companyName];
      const fullName = nameParts.filter((part) => part !== "").join(" ");

      return fullName ? fullName : "-";
    },
    renderCell: (params: any) => {
      const { firstName = "", lastName = "", companyName = "" } = params.row;
      const nameParts = [firstName, lastName, companyName];
      const fullName = nameParts.filter((part) => part !== "").join(" ");
      // console.log("contactType",contactType)
      return (
        <Link
          style={{
            display: "inline-block",
            maxWidth: "240px", // This controls truncation
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "middle",
          }}
          to={`/reactcontact/${contactType}/${params.row.contactId}`}
          // style={{ whiteSpace: "nowrap" }}
        >
          {fullName ? fullName : "-"}
        </Link>
      );
    },
    width: 250,
    defaultChecked: true,
  },
  {
    field: "firstName",
    headerName: "First Name",
    width: 250,
    defaultChecked: false,
  },
  {
    field: "lastName",
    headerName: "Last Name",
    width: 170,
    defaultChecked: false,
  },
  {
    field: "companyName",
    headerName: "Company Name",
    width: 300,
    defaultChecked: false,
    filtering: false,
  },
  {
    field: "mobNo",
    headerName: "Contact No.",
    filtering: false,
    renderCell: (params: any) => {
      const mobile = params.row.mobNo;
      // if prefix is zero (or missing), default to "91"
      const prefix =
        params.row.countryDialCodePrefix === 0
          ? "91"
          : params.row.countryDialCodePrefix;

      return mobile ? `+${prefix}-${mobile}` : "";
    },
    width: 200,
  },
  {
    field: "email",
    renderCell: (params: any) =>
      params.row.email === "" ? "" : params.row.email,
    headerName: "Email Id",
    width: 200,
    defaultChecked: true,
    filtering: false,
  },
  {
    field: "telephone",
    headerName: "Telephone No.",
    width: 150,
    defaultChecked: false,
  },
  {
    field: "gstType",
    headerName: "GST Type",
    renderCell: (params: any) => {
      const vatNo = params.row.vatNo;
      return vatNo && vatNo.trim().length > 1 ? "" : params.row.gstType?.trim() ? params.row.gstType : "Unregistered";
    },
    width: 130,
    defaultChecked: false,
    filtering: true,
  },
  {
    field: "gstin",
    headerName: "GSTIN",
    width: 150,
    defaultChecked: false,
    filtering: false,
  },
  {
    field: "panNo",
    headerName: "PAN No.",
    width: 130,
    defaultChecked: false,
    filtering: false,
  },
  {
    headerName: "Address Line 1",
    field: "addressLine1",
    width: 360,
    defaultChecked: false,
  },
  {
    headerName: "Address Line 2",
    field: "addressLine2",
    width: 360,
    defaultChecked: false,
  },
  {
    headerName: "Pincode",
    field: "pinCode",
    width: 100,
    defaultChecked: false,
    filtering: true,
  },
  {
    headerName: "DOB",
    field: "dateOfBirth",
    width: 120,
    defaultChecked: false,
  },
  {
    headerName: "Opening Balance",
    field: "openingAmount",
    width: 150,
    defaultChecked: false,
    renderCell: (params: any) =>
      Number(params.row.openingAmount).toFixed(sessionList?.decimalPoint || 2),
  },
  {
    headerName: "CR/DR",
    field: "openingType",
    width: 150,
    defaultChecked: false,
  },
  {
    headerName: "City",
    field: "cityName",
    width: 150,
    defaultChecked: false,
    filtering: true,
  },
  {
    headerName: "State",
    field: "stateName",
    width: 150,
    defaultChecked: false,
    filtering: true,
  },
  {
    headerName: "Country",
    field: "countryName",
    width: 150,
    defaultChecked: false,
    filtering: true,
  },
  {
    headerName: "Created By",
    field: "createdByName",
    width: 150,
    defaultChecked: false,
    filtering: true,
  },
  {
    headerName: "Location",
    field: "location",
    width: 150,
    filtering: true,
    defaultChecked: false,
  },
];

export const additionalFieldColumns = ({
    handleEditCustomer,
    handleRowMenuOpen,
    openRowMenuId,
    menuRef,
    handleDeleteCustomer,
    handleActiveDeactiveCustomer,
    dynamicMenuAction,
    tabView,
    contactType,
    sessionBranchId,
    sessionList,
    handleOpenEditPointDialog,
    handleResetPoint,
    
}: CommonColumnsProps): Column[] => 
{
  const isOpen = openRowMenuId ! == null ? false : true;
  return [
    {
      field: "action",
      headerName: "Action",
      width: 70,
      defaultChecked: true,
      renderCell: (params: any) => (
        <div className="d-flex justify-content-center">
          {params.row.branchId === sessionBranchId && params?.row?.isDefault === 0  && (
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                onClick={(event) =>
                  handleRowMenuOpen(event, params.row.contactId)
              }
                className={`btn btn-trigger action-btn dropdown-toggle btn-icon me-n1 ${
                  isOpen ? "show" : ""
                }`}
                aria-expanded={isOpen}
              >
                <TfiMoreAlt />
              </DropdownToggle>

             {openRowMenuId ===params.row.contactId  && 
              <DropdownMenu
                container={document.body}
                ref={menuRef}
                style={{
                  minWidth: "8rem",
                  zIndex: 9999,
                  display: isOpen ? "block" : "none",
                }}
              >
                <OptionMenu
                  menuItems={
                    <ActionMenuItems
                      row={params.row}
                      tabView={tabView}
                      contactType={contactType}
                      isEdit={dynamicMenuAction?.Edit === 1}
                      isDelete={dynamicMenuAction?.Delete === 1}
                      isEditPoints={
                        contactType === "customers" &&
                        sessionList?.companyId == sessionList?.branchId &&
                        Boolean(dynamicMenuAction?.loyalty)
                      }
                      isRefreshPoint={
                        contactType === "customers" &&
                        sessionList?.companyId == sessionList?.branchId &&
                        Boolean(dynamicMenuAction?.loyalty)
                      }
                      handleEdit={handleEditCustomer}
                      handleDelete={handleDeleteCustomer}
                      handleActiveDeactive={handleActiveDeactiveCustomer}
                      handleOpenEditPointDialog={handleOpenEditPointDialog}
                      handleResetPoint={handleResetPoint}
                      handleActiveDeactiveCustomer={
                        handleActiveDeactiveCustomer
                      }
                    />
                  }
                />
              </DropdownMenu>}
            </UncontrolledDropdown>
          )}
        </div>
      ),
    },
  ];};